import defaultMock from '../../language_assessment/examMockConfig';

const examMockConfig = { ...defaultMock, title: 'ASSESS-557_TESTER' };

export default examMockConfig;
